import React, { useState, useEffect, useCallback } from 'react';
import { getDashboard } from '../services/api';
import AdminDashboard from '../components/Dashboard/AdminDashboard';
import CajeroDashboard from '../components/Dashboard/CajeroDashboard';
import AlmaceneroDashboard from '../components/Dashboard/AlmaceneroDashboard';
import '../styles/Dashboard.css';

function todayLocal() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

function Dashboard({ businessId }) {
  const [view, setView] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [lastUpdated, setLastUpdated] = useState(null);
  const [period, setPeriod] = useState('today');
  const [date, setDate] = useState(todayLocal());

  const fetchDashboardData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getDashboard(businessId, { period, date });
      setView(response.data.view);
      setData(response.data.data);
      setLastUpdated(Date.now());
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
      console.error('Error fetching dashboard:', err);
    } finally {
      setLoading(false);
    }
  }, [businessId, period, date]);

  useEffect(() => {
    if (businessId) fetchDashboardData();
  }, [businessId, fetchDashboardData]);

  const handlePeriodChange = (newPeriod, newDate) => {
    setPeriod(newPeriod);
    setDate(newDate);
  };

  if (loading && !data) return <div className="dsh-loading">Cargando dashboard...</div>;
  if (error) return <div className="dsh-error">Error: {error}</div>;
  if (!data) return <div className="dsh-loading">No hay datos disponibles</div>;

  if (view === 'cajero') return <CajeroDashboard data={data} />;
  if (view === 'almacenero') return <AlmaceneroDashboard data={data} />;
  return (
    <AdminDashboard
      data={data}
      period={period}
      date={date}
      onPeriodChange={handlePeriodChange}
      onRefresh={fetchDashboardData}
      lastUpdated={lastUpdated}
      loading={loading}
    />
  );
}

export default Dashboard;
